/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContentListEntryFromJSON, ContentListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfContentListEntryFromJSON(json) {
    return PagedResponseOfContentListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfContentListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(ContentListEntryFromJSON)),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements']
    };
}
export function PagedResponseOfContentListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'numberOfElements': value.numberOfElements,
        'nextPage': PageRequestToJSON(value.nextPage),
        'metaData': MetaDataToJSON(value.metaData),
        'hasPrevious': value.hasPrevious,
        'size': value.size,
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasNext': value.hasNext,
        'page': value.page,
        'entries': value.entries === undefined ? undefined : (value.entries.map(ContentListEntryToJSON)),
        'totalElements': value.totalElements
    };
}
